import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { HvlBaseModel } from '@hvlng/framework-bff/core/src/model/hvl-base-model';
import {
    HrMasterDataRecordHistoryComponent
} from '../component/hr-master-data-record-history/hr-master-data-record-history.component';

@Injectable({
    providedIn: 'root',
})
export class HrMasterDataRecordHistoryService {

    protected dialogService = inject(DialogService);
    protected translateService = inject(TranslateService);


    public openRecordHistory(model: HvlBaseModel){
        this.dialogService.open(HrMasterDataRecordHistoryComponent, {
            header: this.translateService.instant('hrMasterDataRecordHistory.recordHistory'),
            data: model,
            width: '60%',
            contentStyle: { overflow: 'auto' },
        });
    }
}
